<template>
  <v-form ref="form">
    <v-row class="containerAddCost">
      <v-col cols="12">
        <h3 class="black--text mb-4">Adicionar Cotação</h3></v-col
      >
      <v-row>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            id-element="insuranceTypeQuotation"
            placeholder="Escolher"
            label-text="Tipo de Seguro"
            v-model="newCost.insuranceType"
            :items="insuranceType"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
          />
        </v-col>
        <v-col class="pr-sm-2">
          <BaseFormSelect
            id-element="insuranceCompanyQuotation"
            placeholder="Escolher"
            label-text="Seguradora"
            v-model="newCost.insuranceCompany"
            :items="insuranceCompanyOptions"
            item-text="nome"
            item-value="codigo"
            required
            :rules="[requiredInput]"
            :return-object="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="insuredAreaQuotation"
            placeholder="0,00"
            label-text="Área (ha)"
            v-model="newCost.insuredArea"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :errorMessages="areaPlantadaErrorMessages"
            :v-on:change="validateAreaPlantada()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            id-element="claimTypeQuotation"
            placeholder="Escolher"
            label-text="Regulação Sinistro"
            v-model="newCost.claimType"
            :items="claimType"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            id-element="coverageQuotation"
            placeholder="Escolher"
            label-text="Coberturas"
            v-model="newCost.coverage"
            :items="coverage"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
          />
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="insuredValueQuotation"
            placeholder="0,00"
            label-text="Importância Segurada"
            v-model="newCost.insuredValue"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :errorMessages="insuredValueErrorMessages"
            :v-on:change="validateInsuredValue()"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="grantedProductionQuotation"
            placeholder="0,00"
            label-text="Produtividade Garantida"
            v-model="newCost.grantedProduction"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :errorMessages="grantedProductionErrorMessage"
            :v-on:change="validateGrantedProduction()"
          />
        </v-col>
        <v-col v-if="isInsuranceTypeProductivity" class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="costPerSacQuotation"
            placeholder="0,00"
            label-text="Preço da Saca"
            v-model="newCost.costPerSac"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :errorMessages="costPerSacErrorMessages"
            :v-on:change="validateCostPerSac()"
          />
        </v-col>
        <v-col v-if="!isInsuranceTypeProductivity" class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="costPerSacQuotation"
            placeholder="0,00"
            label-text="Valor por Hectare (R$)"
            v-model="newCost.hectareCost"
            required
            :rules="[requiredInput, aboveZero]"
            :disabled="false"
            :errorMessages="hectareCostErrorMessages"
            :v-on:change="validateHectareCost()"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="totalQuotation"
            placeholder="0,00"
            label-text="Preço Total"
            v-model="newCost.total"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :errorMessages="totalErrorMessages"
            :v-on:change="validateTotal()"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="comissaoQuotation"
            label-text="Comissão(%)"
            v-model="newCost.comissao"
            required
            :rules="[requiredInput]"
            :disabled="false"
            :money="typeDecimal"
          />
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="federalSubventionQuotation"
            placeholder="0,00"
            label-text="Subvenção Federal"
            v-model="newCost.federalSubvention"
            :disabled="false"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="stateSubventionQuotation"
            placeholder="0,00"
            label-text="Subvenção Estadual"
            v-model="newCost.stateSubvention"
            :disabled="false"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="insuredPriceQuotation"
            label-text="Preço do Segurado"
            v-model="newCost.insuredPrice"
            required
            :disabled="false"
            :readonly="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="farmerPriceQuotation"
            label-text="Preço do produtor (R$/ha)"
            v-model="newCost.farmerPrice"
            required
            :disabled="false"
            :readonly="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            id-element="paymentFormQuotation"
            placeholder="Escolher"
            label-text="Forma de Pagamento"
            v-model="newCost.paymentForm"
            :items="paymentForm"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" class="pr-sm-5">
          <BaseButton
            ref="formFocus"
            v-html="saveText"
            class="white--text secondary"
            width="100%"
            @click="adicionar()"
          />
        </v-col>
        <v-col v-if="this.itemIndex != -1" cols="3" class="pr-sm-5">
          <BaseButton
            ref="formFocus"
            v-html="'Cancelar'"
            class="white--text secondary"
            width="100%"
            @click="cancelar()"
          />
        </v-col>
      </v-row>
    </v-row>
  </v-form>
</template>
<script>
const INSURANCE_TYPE = [
  {
    id: "produtividade",
    nome: "Produtividade"
  },
  {
    id: "custeio",
    nome: "Custeio"
  }
];
const CLAIM_TYPE = [
  {
    id: "media_area",
    nome: "Média da área atual"
  },
  {
    id: "talhao",
    nome: "Talhão"
  }
];
const COVERAGE_TYPE = [
  {
    id: "basica",
    nome: "Básica"
  },
  {
    id: "basica_replantio",
    nome: "Básica + Replantio"
  }
];
const PAYMENT_FORM = [
  {
    id: "1",
    nome: "À Vista"
  },
  {
    id: "2",
    nome: "2 Parcelas"
  },
  {
    id: "3",
    nome: "3 Parcelas"
  },
  {
    id: "4",
    nome: "4 Parcelas"
  },
  {
    id: "5",
    nome: "5 Parcelas"
  }
];
const defaultCost = {
  id: null,
  numero: null,
  insuranceType: INSURANCE_TYPE[0],
  insuranceCompany: null,
  insuredArea: 0,
  claimType: null,
  coverage: null,
  insuredValue: 0,
  grantedProduction: 0,
  costPerSac: 0, // se for produvidade preencher este campo
  hectareCost: 0, // se for custeio preencher este campo
  total: 0,
  federalSubvention: 0,
  stateSubvention: 0,
  insuredPrice: 0,
  farmerPrice: 0,
  paymentForm: PAYMENT_FORM[0],
  visible: true,
  comissao: 8
};
const money = {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  precision: 2,
  masked: false /* doesn't work with directive */
};

import { requiredInput, maxLengthNumber } from "@/utils/rules.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import _ from "lodash";
import BaseMoney from "../../../components/base/BaseMoney.vue";

export default {
  components: { BaseMoney },
  data: () => ({
    formValid: true,
    loading: false,
    requiredInput,
    timeout: null,
    maxLengthNumber,
    // novos campos agro
    quotationCosts: [],
    insuranceType: INSURANCE_TYPE,
    claimType: CLAIM_TYPE,
    coverage: COVERAGE_TYPE,
    paymentForm: PAYMENT_FORM,
    listInsuranceCompany: null, //ver como pegar a lista de seguradoras
    listInsuranceCompanyQuotation: [],
    newCost: defaultCost,
    typeDecimal: money,
    comissao: 8,
    areaPlantadaErrorMessages: [],
    costPerSacErrorMessages: [],
    hectareCostErrorMessages: [],
    grantedProductionErrorMessage: [],
    insuredValueErrorMessages: [],
    totalErrorMessages: []
  }),
  created() {
    if (
      this.itemIndex < 0 ||
      this.itemIndex >= this.formCosts.quotationCosts.length
    ) {
      this.newCost = _.cloneDeep(defaultCost);
    } else {
      this.newCost = _.cloneDeep(this.formCosts.quotationCosts[this.itemIndex]);
    }
    this.fetchOptions();
    this.focusForm();
  },
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", [
      "insuredByNameOrCPFCNPJ",
      "insuranceCompanyOptions"
    ]),
    saveText() {
      return this.itemIndex == -1 ? "Adicionar" : "Salvar";
    },
    formCosts: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isInsuranceTypeProductivity() {
      return this.newCost.insuranceType?.id == "produtividade";
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  methods: {
    ...mapActions("quotation", [
      "requestInsuredByNameOrCPFCNPJ",
      "fetchInsuranceCompany"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    async fetchOptions() {
      const payload = {
        somenteAtivos: true,
        modalidade: "agricola"
      };
      await this.withLoading(
        Promise.all([this.fetchInsuranceCompany(payload)])
      );
    },
    focusForm() {
      setTimeout(() => {
        this.$refs.formFocus.$el.focus();
      }, 200);
    },
    aboveZero(value) {
      return value > 0 || "O valor deve ser maior do que 0.";
    },
    cancelar() {
      this.$emit("cancel");
    },
    CalcularPrecoSegurado() {
      let priceTotal = this.newCost.total ?? 0;
      let subvencaoEstadual = this.newCost.stateSubvention ?? 0;
      let subvencaoFederal = this.newCost.federalSubvention ?? 0;

      let price = priceTotal - subvencaoEstadual - subvencaoFederal;

      if (price > 0) {
        this.newCost.insuredPrice = price.toFixed(2);
      }
    },
    CalcularPrecoProdutor() {
      let priceInsured = this.newCost.insuredPrice ?? 0;
      let areaInsured = this.newCost.insuredArea ?? 0;

      let price = priceInsured / areaInsured;

      if (price > 0) {
        this.newCost.farmerPrice = price.toFixed(2);
      }
    },
    validar() {
      return (
        this.$refs.form.validate() &&
        this.newCost.insuredArea > 0 &&
        this.newCost.insuredValue > 0 &&
        this.newCost.grantedProduction > 0 &&
        (this.isInsuranceTypeProductivity
          ? this.newCost.costPerSac > 0
          : this.newCost.hectareCost > 0) &&
        this.newCost.total > 0 &&
        this.newCost.insuredPrice > 0 &&
        this.newCost.farmerPrice > 0 &&
        this.newCost.comissao >= 0
      );
    },
    validateAreaPlantada() {
      if (
        this.newCost.insuredArea > 0 &&
        this.areaPlantadaErrorMessages.length != 0
      ) {
        this.areaPlantadaErrorMessages = [];
      }
    },
    validateInputBaseMoney() {
      if (
        !this.newCost.insuredArea > 0 &&
        this.areaPlantadaErrorMessages.length == 0
      ) {
        this.areaPlantadaErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newCost.costPerSac > 0 &&
        this.costPerSacErrorMessages.length == 0
      ) {
        this.costPerSacErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newCost.hectareCost > 0 &&
        this.hectareCostErrorMessages.length == 0
      ) {
        this.hectareCostErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newCost.grantedProduction > 0 &&
        this.grantedProductionErrorMessage.length == 0
      ) {
        this.grantedProductionErrorMessage.push("Este campo é obrigatório");
      }

      if (
        !this.newCost.insuredValue > 0 &&
        this.insuredValueErrorMessages.length == 0
      ) {
        this.insuredValueErrorMessages.push("Este campo é obrigatório");
      }

      if (!this.newCost.total > 0 && this.totalErrorMessages.length == 0) {
        this.totalErrorMessages.push("Este campo é obrigatório");
      }
    },
    validateCostPerSac() {
      if (
        this.newCost.costPerSac > 0 &&
        this.costPerSacErrorMessages.length != 0
      ) {
        this.costPerSacErrorMessages = [];
      }
    },
    validateHectareCost() {
      if (
        this.newCost.hectareCost > 0 &&
        this.hectareCostErrorMessages.length != 0
      ) {
        this.hectareCostErrorMessages = [];
      }
    },
    validateGrantedProduction() {
      if (
        this.newCost.grantedProduction > 0 &&
        this.grantedProductionErrorMessage.length != 0
      ) {
        this.grantedProductionErrorMessage = [];
      }
    },
    validateInsuredValue() {
      if (
        this.newCost.insuredValue > 0 &&
        this.insuredValueErrorMessages.length != 0
      ) {
        this.insuredValueErrorMessages = [];
      }
    },
    validateTotal() {
      if (this.newCost.total > 0 && this.totalErrorMessages.length != 0) {
        this.totalErrorMessages = [];
      }
    },
    adicionar() {
      if (!this.validar()) {
        this.validateInputBaseMoney();
        this.showAlertNotification({
          message: "Todos os campos devem ser preenchidos",
          type: "error"
        });
        return;
      }

      if (this.itemIndex == -1) {
        this.formCosts.quotationCosts.push(this.newCost);
      } else {
        if (this.itemIndex < this.formCosts.quotationCosts.length) {
          this.formCosts.quotationCosts[this.itemIndex] = this.newCost;
          this.formCosts.quotationCosts = _.cloneDeep(
            this.formCosts.quotationCosts
          );
        }
      }
      this.$emit("update:enableCost", false);
    }
  },
  watch: {
    "newCost.insuredPrice": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.insuredPrice == oldValue?.insuredPrice
      )
        return this.CalcularPrecoProdutor();
    },
    "newCost.insuredArea": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.insuredArea == oldValue?.insuredArea
      )
        return this.CalcularPrecoProdutor();
    },
    "newCost.stateSubvention": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.stateSubvention == oldValue?.stateSubvention
      )
        return this.CalcularPrecoSegurado();
    },
    "newCost.federalSubvention": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.federalSubvention == oldValue?.federalSubvention
      )
        return this.CalcularPrecoSegurado();
    },
    "newCost.total": function(newValue, oldValue) {
      if (
        !newValue ||
        newValue == oldValue ||
        newValue?.total == oldValue?.total
      )
        return this.CalcularPrecoSegurado();
    }
  },
  props: {
    value: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    itemIndex: {
      type: Number
    }
  }
};
</script>
<style lang="sass">
.containerAddCost
  max-width: 90% !important
  margin: 0 auto !important
  padding: 0 auto !important
</style>
